import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

const requestError = (message, code, card = false, setupUrl = "") => {
  const error = new Error(message);
  error.code = code;
  error.card = card;
  error.setupUrl = setupUrl;
  return error;
};

export const scanConfig = async (userId, credentials) => {
  if (!userId || !credentials) {
    throw requestError(
      "User ID and credentials are required",
      "INVALID_INPUT"
    );
  }

  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) {
      throw requestError(
        "Authentication token is missing",
        "UNAUTHORIZED"
      );
    }

    const response = await fetch(`${api_base_url}/api/${api_key}/post/${userId}/gcp/scanConfig`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ credentials }),
    });

    const data = await response.json();
    if (!response.ok || data.success === false) {
      throw requestError(
        data.message || "Request failed",
        data.code || "UNKNOWN_ERROR",
        data.meta?.showUpgradeCard || false,
        data.meta?.setupUrl || ""
      );
    }

    return data;
  } catch (error) {
    console.error('Error during GCP scan:', error);
    throw requestError(
      error.message || "Network error",
      error.code || "NETWORK_ERROR",
      error.card || false,
      error.setupUrl || ""
    );
  }
};

export const scanGcsUrl = async (userId, url) => {
	if (!userId || !url) {
		throw new Error('User ID and URL are required');
	}	
	
  try {
    const token = sessionStorage.getItem('authToken');
    const response = await fetch(`${api_base_url}/api/${api_key}/post/${userId}/gcp/scanGcsUrl`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // Include the Bearer token in the header
      },
      body: JSON.stringify({ url }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to Scan Gcp Keys');
    }

    return response.json();
  } catch (error) {
    console.error('Error during Gcp scan:', error);
    throw error;
  }
};

export const scanGceIp = async (userId, ip) => {
	if (!userId || !ip) {
		throw new Error('User ID and IP are required');
	}	

  try {
    const token = sessionStorage.getItem('authToken');
    const response = await fetch(`${api_base_url}/api/${api_key}/post/${userId}/gcp/scanGceIp`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // Include the Bearer token in the header
      },
      body: JSON.stringify({ ip }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to Scan Gcp Keys');
    }

    return response.json();
  } catch (error) {
    console.error('Error during Gcp scan:', error);
    throw error;
  }
};

export const checkIpType = async (ip, d_id) => {
  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/${d_id}/network/gcp/checkIpType`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ip}),
    });
    
    const data = await response.json();   
    return data;  
  } catch (err) {
    throw new Error(err.message);  
  }
};
